import { createContext, type ReactNode, useContext } from "react";

interface FeatureFlagsState {
  /** Aktif feature key listesi (GET /api/features sonucu — apps/web sağlar). */
  features: string[];
  isLoading: boolean;
}

/** Varsayılan: provider yoksa hiçbir feature aktif değildir (en az yetki, kriter 11). */
const FeatureFlagsContext = createContext<FeatureFlagsState>({ features: [], isLoading: false });

export interface FeatureFlagsProviderProps {
  features: string[];
  isLoading?: boolean;
  children: ReactNode;
}

export function FeatureFlagsProvider({
  features,
  isLoading = false,
  children,
}: FeatureFlagsProviderProps) {
  return (
    <FeatureFlagsContext.Provider value={{ features, isLoading }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}

export function useFeature(featureKey: string): { enabled: boolean; isLoading: boolean } {
  const { features, isLoading } = useContext(FeatureFlagsContext);
  return { enabled: features.includes(featureKey), isLoading };
}

export interface FeatureGateProps {
  featureKey: string;
  children: ReactNode;
  fallback?: ReactNode;
}

export function FeatureGate({ featureKey, children, fallback = null }: FeatureGateProps) {
  const { enabled, isLoading } = useFeature(featureKey);
  if (isLoading) return null;
  return <>{enabled ? children : fallback}</>;
}
